export default __webpack_public_path__ + "static/media/backMobileHeader.c84e27ae.svg";